import { Box, Stack } from '@mui/material'
import { GLItemDTO } from '../../../DTO/GLItemDTO'
import { TagSelector } from '../tags/TagSelector'
import { TagDTO, TagType } from '../../DTO/TagDTO'
import { PERSON_TAG_CONFIGS } from './logChatMsgHelpers'

export default function LogChatMsgPersonTags({
  glitem,
}: {
  glitem: GLItemDTO
}) {
  if (!glitem.person) {
    return null
  }
  const person = glitem.person
  return (
    <Stack
      className="LogChatMsg-personTags"
      direction="row"
      spacing={1}
      useFlexGap
      sx={{ flexWrap: 'wrap' }}
    >
      {PERSON_TAG_CONFIGS.map(t => (
        <Box key={`person-tag-selector-${glitem.id}-${person.id}-${t.kind}`}>
          <TagSelector
            parentId={glitem.id}
            kind={t.kind as TagType}
            mode={t.mode}
            selectedTags={person.getTagsByKind(t.kind as TagType, 'tag')}
            selectTag={async (tag: TagDTO) => {
              await person.setTag(tag, true)
            }}
            unsetTag={async (tag: TagDTO) => {
              await person.unsetTag(tag)
            }}
            readMode={false}
          />
        </Box>
      ))}
    </Stack>
  )
}
